module.exports = __webpack_public_path__ + "4c099e7565866ed99fae70ea1bdbe248.msgpack";


/*****************
 ** WEBPACK FOOTER
 ** ./~/file-loader!./src/game/models/cube.msgpack
 ** module id = 592
 ** module chunks = 0
 **/